import { Box, Typography } from '@mui/material';
import { TWhatAccountExist } from 'modules/sign-up/constants';

interface Props {
  whatAccountExist?: TWhatAccountExist;
  handleOpenLogin: () => void;
}

export const styles = {
  accountExistContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: 300,
    width: '100%',
    textAlign: 'center',
    gap: 2,
  },
  title: {
    mt: 2,
    fontWeight: 600,
    fontSize: 22,
  },
  loginLink: {
    color: 'primary.main',
    cursor: 'pointer',
    mt: 1,
    fontWeight: 500,
    textDecoration: 'underline',
  },
};

export function ExistingAccountNotice({ whatAccountExist, handleOpenLogin }: Props) {
  switch (whatAccountExist) {
    case TWhatAccountExist.CARRIC_DB:
      return (
        <Box sx={styles.accountExistContainer}>
          <img alt="contact-icon" src="assets/images/sheet_icon.png" />
          <Typography sx={styles.title}>You already have an account!</Typography>
          <Typography sx={styles.loginLink} onClick={handleOpenLogin}>
            Log in to your account.
          </Typography>
        </Box>
      );
    case TWhatAccountExist.AOS_DB:
      return (
        <Box sx={styles.accountExistContainer}>
          <Typography variant="h5" sx={styles.title}>
            You already have an account!
          </Typography>
          <Typography>Please contact your rep to receive an invite!</Typography>
        </Box>
      );
    default:
      return (
        <Box sx={styles.accountExistContainer}>
          <img alt="contact-icon" src="assets/images/sheet_icon.png" />
          <Typography variant="h5" sx={styles.title}>
            Something went wrong during email validation. Please check your email address and try again.
          </Typography>
        </Box>
      );
  }
}
